module.exports = __webpack_public_path__ + "img/Menu-01-.1bf280a0.png";